
import React from "react";
import { FormField, FormItem, FormControl, FormLabel, FormMessage } from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { Control } from "react-hook-form";
import { Link } from "react-router-dom";
import { ContactFormValues } from "./schema";

interface PrivacyConsentProps {
  control: Control<ContactFormValues>;
}

export function PrivacyConsent({ control }: PrivacyConsentProps) {
  return (
    <FormField
      control={control}
      name="consent"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start space-x-3 space-y-0 mb-6">
          <FormControl>
            <Checkbox
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <div className="space-y-1 leading-none">
            <FormLabel className="font-normal">
              I agree to the <Link to="/privacy-policy" className="text-grandpal-green underline hover:text-grandpal-green-light">privacy policy</Link> and consent to being contacted by Grandpal.
            </FormLabel>
            <FormMessage />
          </div>
        </FormItem>
      )}
    />
  );
}
